import packageJson from '../package.json';

const id = packageJson.name;
const SOPClassHandlerName = 'carian-diagnosis';
const SOPClassHandlerId = `${id}.sopClassHandlerModule.${SOPClassHandlerName}`;
console.log(SOPClassHandlerId);
export { id, SOPClassHandlerId, SOPClassHandlerName };
